import { BenefitsContainer } from "../components/benefitsHistalmut/BenefitHishtalmut"
import Button from "../components/button/Button"
import styles from "./ThirdScreen.module.css"

const ThirdScreen = () => {
    return <>
        <div className={styles.title}>למה דווקא עכשיו?</div>
        <div className={styles.description}>תכלס, אתה לא חייב לעשות צעד דווקא עכשיו.. השאלה האחרת היא:</div>
        <div className={styles.title}>כמה זה שווה לך?</div>
        <BenefitsContainer/>

        <div className={styles.description}>תכלס? שנינו יודעים שאם תצא מהדף הזה עכשיו בלי לעשות כלום, אתה תחשוב על הנושא כמה שעות ותמשיך באותו הלופ הקיים...</div>
        
        <div className={styles.title}>יש לך 2 אפשרויות</div>
        
        <div className={styles.optionContainer}>
            <div className={styles.option}>
                <div className={styles.optionNumber}>1</div>
                <div className={styles.optionTitle}>להמשיך לדחות</div>
                <div className={styles.optionText}>
                    לצאת מהדף, להגיד לעצמך "אני אברר כבר בזמן אחר"... ובעוד חצי שנה להבין שהפסדת עוד אלפי שקלים שיכלו להיות שלך.
                </div>
            </div>

            <div className={styles.option}>
                <div className={styles.optionNumber}>2</div>
                <div className={styles.optionTitle}>לקחת החלטה עכשיו</div>
                <div className={styles.optionText}>
                    5 דקות של שיחה, תשובות ברורות לכל השאלות והבנה של איך אנחנו יכולות לעזור לך.
                </div>
            </div>
        </div>

        <div className={styles.urgencyText}>
            בוא נהיה כנים - אתה כבר יודע מה הבחירה הנכונה. השאלה היחידה היא אם אתה מוכן לעשות משהו בקשר לזה.
        </div>

        <div className={styles.finalPush}>
            <div className={styles.finalTitle}>אז מה עכשיו?</div>
            <div className={styles.finalText}>תלחץ על הכפתור שנמצא ממש כאן למטה, נבדוק התאמה ואולי נצא גם יחד לדרך משותפת </div>
           
        </div>
         <Button text="תלחץ כאן ואנחנו מדברים!"/>
    </>
}

export default ThirdScreen